import { render, staticRenderFns } from "./DepartureTransferState.vue?vue&type=template&id=22a7acdb"
import script from "./DepartureTransferState.vue?vue&type=script&lang=js"
export * from "./DepartureTransferState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports